import { axiosMaximus } from './axiosMaximus';
import { makeConfig, makeUrl } from './basicHelpers';

export const basicRequestPost = async (relativeUrl: string, data: any, requestConfig = {}) => {
  try {
    return await axiosMaximus.post(makeUrl(relativeUrl), data, makeConfig(requestConfig));
  } catch (error) {
    // @ts-ignore
    delete error.stack;
    throw error;
  }
};
